import moment from "moment/moment";
import { forEach, map } from "lodash";

export const getXlFieldsBySettingType = {
  SERVICE_TYPE: (data) => {
    return {
      Code: data.code,
      Version: data.version,
      Name: data.name,
      Surcharge: data.surcharge || "-",
      "Valid From": data.validFrom,
      "Valid To": data.validTo,
      Type: data?.type?.replaceAll("_", " ") || "-",
      "is Fixed Amount": data.isFixedAmount ? "Yes" : "No",
      "Fixed Amount": data.fixedAmount || "-",
      "is Percentage": data.isPercentage ? "Yes" : "No",
      Percentage: data.percentage || "-",
      "Cap Amount": data.capAmount || "-",
      "Customer Name": map(data?.customerRates, (ratesObj) => {
        return `${ratesObj.orgName}\n`;
      })
        .toString()
        .replaceAll(",", ""),
      " Surcharge Type ": map(data?.customerRates, (ratesObj) => {
        return `${ratesObj.surchargeType}\n`;
      })
        ?.toString()
        .replaceAll(",", ""),
      " Fixed Amount ": map(data?.customerRates, (ratesObj) => {
        return `${
          ratesObj.data?.surcharge?.fixedAmount
            ? " RM " + ratesObj.data?.surcharge?.fixedAmount
            : "-"
        } \n`;
      })
        ?.toString()
        .replaceAll(",", ""),
      " Percentage ": map(data?.customerRates, (ratesObj) => {
        return `${
          ratesObj.data?.surcharge?.percentage ? ratesObj.data?.surcharge?.percentage + "%" : "-"
        } \n`;
      })
        ?.toString()
        .replaceAll(",", ""),
      " Cap Amount ": map(data?.customerRates, (ratesObj) => {
        return `${
          ratesObj.data?.surcharge?.capAmount ? " RM " + ratesObj.data?.surcharge?.capAmount : "-"
        } \n`;
      })
        ?.toString()
        .replaceAll(",", ""),
      "Created Date": moment(data.createdAt).format("DD-MM-YYYY HH:MM:SS"),
      "Created By": data.createdBy || "-",
      "Updated Date": moment(data.updatedAt).format("DD-MM-YYYY HH:MM:SS"),
      "Updated By": data.updatedBy || "-",
    };
  },

  SPECIAL_CONDITION: (data) => {
    return {
      Code: data.code,
      Version: data.version,
      Name: data.name,
      "Max Weight": data.maxWeight,
      "Max Dimension": data.length + " x " + data.width + " x " + data.height,
      Surcharge: data.surcharge || "-",
      Type: data?.type?.replaceAll("_", " ") || "-",
      "Valid From": data.validFrom,
      "Valid To": data.validTo,
      "is Fixed Amount": data.isFixedAmount ? "Yes" : "No",
      "Fixed Amount": data.fixedAmount || "-",
      "is Percentage": data.isPercentage ? "Yes" : "No",
      Percentage: data.percentage || "-",
      "Cap Amount": data.capAmount || "-",
      Length: data.length || "-",
      Width: data.width || "-",
      Height: data.height || "-",
      "Customer Name": map(data?.customerRates, (ratesObj) => {
        return `${ratesObj.orgName}\n`;
      })
        .toString()
        .replaceAll(",", ""),
      " Surcharge Type ": map(data?.customerRates, (ratesObj) => {
        return `${ratesObj.surchargeType}\n`;
      })
        ?.toString()
        .replaceAll(",", ""),
      " Fixed Amount ": map(data?.customerRates, (ratesObj) => {
        return `${
          ratesObj.data?.surcharge?.fixedAmount
            ? " RM " + ratesObj.data?.surcharge?.fixedAmount
            : "-"
        } \n`;
      })
        ?.toString()
        .replaceAll(",", ""),
      " Percentage ": map(data?.customerRates, (ratesObj) => {
        return `${
          ratesObj.data?.surcharge?.percentage ? ratesObj.data?.surcharge?.percentage + "%" : "-"
        } \n`;
      })
        ?.toString()
        .replaceAll(",", ""),
      " Cap Amount ": map(data?.customerRates, (ratesObj) => {
        return `${
          ratesObj.data?.surcharge?.capAmount ? " RM " + ratesObj.data?.surcharge?.capAmount : "-"
        } \n`;
      })
        ?.toString()
        .replaceAll(",", ""),
      "Created Date": moment(data.createdAt).format("DD-MM-YYYY HH:MM:SS"),
      "Created By": data.createdBy || "-",
      "Updated Date": moment(data.updatedAt).format("DD-MM-YYYY HH:MM:SS"),
      "Updated By": data.updatedBy || "-",
    };
  },

  SPECIAL_CARE: (data) => {
    return {
      Code: data.code,
      Version: data.version,
      Name: data.name,
      "Max Weight": data.maxWeight,
      "Max Dimension": data.length + " x " + data.width + " x " + data.height,
      Surcharge: data.surcharge || "-",
      Type: data?.type?.replaceAll("_", " ") || "-",
      "Valid From": data.validFrom,
      "Valid To": data.validTo,
      "is Fixed Amount": data.isFixedAmount ? "Yes" : "No",
      "Fixed Amount": data.fixedAmount || "-",
      "is Percentage": data.isPercentage ? "Yes" : "No",
      Percentage: data.percentage || "-",
      "Cap Amount": data.capAmount || "-",
      Length: data.length || "-",
      Width: data.width || "-",
      Height: data.height || "-",
      "Customer Name": map(data?.customerRates, (ratesObj) => {
        return `${ratesObj.orgName}\n`;
      })
        .toString()
        .replaceAll(",", ""),
      " Surcharge Type ": map(data?.customerRates, (ratesObj) => {
        return `${ratesObj.surchargeType}\n`;
      })
        ?.toString()
        .replaceAll(",", ""),
      " Fixed Amount ": map(data?.customerRates, (ratesObj) => {
        return `${
          ratesObj.data?.surcharge?.fixedAmount
            ? " RM " + ratesObj.data?.surcharge?.fixedAmount
            : "-"
        } \n`;
      })
        ?.toString()
        .replaceAll(",", ""),
      " Percentage ": map(data?.customerRates, (ratesObj) => {
        return `${
          ratesObj.data?.surcharge?.percentage ? ratesObj.data?.surcharge?.percentage + "%" : "-"
        } \n`;
      })
        ?.toString()
        .replaceAll(",", ""),
      " Cap Amount ": map(data?.customerRates, (ratesObj) => {
        return `${
          ratesObj.data?.surcharge?.capAmount ? " RM " + ratesObj.data?.surcharge?.capAmount : "-"
        } \n`;
      })
        ?.toString()
        .replaceAll(",", ""),
      "Created Date": moment(data.createdAt).format("DD-MM-YYYY HH:MM:SS"),
      "Created By": data.createdBy || "-",
      "Updated Date": moment(data.updatedAt).format("DD-MM-YYYY HH:MM:SS"),
      "Updated By": data.updatedBy || "-",
    };
  },

  DELIVERY_TYPE: (data) => {
    return {
      Code: data.code,
      Version: data.version,
      Name: data.name,
      Surcharge: data.surcharge || "-",
      "Service Types": map(data?.serviceTypes, (type) => {
        return type.name;
      })?.toString(),
      "Valid From": data.validFrom,
      "Valid To": data.validTo,
      "is Fixed Amount": data.isFixedAmount ? "Yes" : "No",
      "Fixed Amount": data.fixedAmount || "-",
      "is Percentage": data.isPercentage ? "Yes" : "No",
      Percentage: data.percentage || "-",
      "Cap Amount": data.capAmount || "-",
      "Customer Name": map(data?.customerRates, (ratesObj) => {
        return `${ratesObj.orgName}\n`;
      })
        .toString()
        .replaceAll(",", ""),
      " Surcharge Type ": map(data?.customerRates, (ratesObj) => {
        return `${ratesObj.surchargeType}\n`;
      })
        ?.toString()
        .replaceAll(",", ""),
      " Fixed Amount ": map(data?.customerRates, (ratesObj) => {
        return `${
          ratesObj.data?.surcharge?.fixedAmount
            ? " RM " + ratesObj.data?.surcharge?.fixedAmount
            : "-"
        } \n`;
      })
        ?.toString()
        .replaceAll(",", ""),
      " Percentage ": map(data?.customerRates, (ratesObj) => {
        return `${
          ratesObj.data?.surcharge?.percentage ? ratesObj.data?.surcharge?.percentage + "%" : "-"
        } \n`;
      })
        ?.toString()
        .replaceAll(",", ""),
      " Cap Amount ": map(data?.customerRates, (ratesObj) => {
        return `${
          ratesObj.data?.surcharge?.capAmount ? " RM " + ratesObj.data?.surcharge?.capAmount : "-"
        } \n`;
      })
        ?.toString()
        .replaceAll(",", ""),
      "Created Date": moment(data.createdAt).format("DD-MM-YYYY HH:MM:SS"),
      "Created By": data.createdBy || "-",
      "Updated Date": moment(data.updatedAt).format("DD-MM-YYYY HH:MM:SS"),
      "Updated By": data.updatedBy || "-",
    };
  },

  LOCATION: (data) => {
    return {
      Code: data.code,
      Version: data.version,
      "Area Name": data.areaName,
      State: map(data.states, (stateObj) => {
        return stateObj.state;
      })?.toString(),
      "Post Codes": map(data.states, (stateObj) => {
        return stateObj.postcodes;
      })?.toString(),
      "Delivery Types": map(data.deliveryTypes, (type) => {
        return type.name;
      })?.toString(),
      Surcharge: data.surcharge || "-",
      Type: data?.type?.replaceAll("_", " ") || "-",
      "Valid From": data.validFrom,
      "Valid To": data.validTo,
      "is Fixed Amount": data.isFixedAmount ? "Yes" : "No",
      "Fixed Amount": data.fixedAmount || "-",
      "is Percentage": data.isPercentage ? "Yes" : "No",
      Percentage: data.percentage || "-",
      "Cap Amount": data.capAmount || "-",
      "Customer Name": map(data?.customerRates, (ratesObj) => {
        return `${ratesObj.orgName}\n`;
      })
        .toString()
        .replaceAll(",", ""),
      " Surcharge Type ": map(data?.customerRates, (ratesObj) => {
        return `${ratesObj.surchargeType}\n`;
      })
        ?.toString()
        .replaceAll(",", ""),
      " Fixed Amount ": map(data?.customerRates, (ratesObj) => {
        return `${
          ratesObj.data?.surcharge?.fixedAmount
            ? " RM " + ratesObj.data?.surcharge?.fixedAmount
            : "-"
        } \n`;
      })
        ?.toString()
        .replaceAll(",", ""),
      " Percentage ": map(data?.customerRates, (ratesObj) => {
        return `${
          ratesObj.data?.surcharge?.percentage ? ratesObj.data?.surcharge?.percentage + "%" : "-"
        } \n`;
      })
        ?.toString()
        .replaceAll(",", ""),
      " Cap Amount ": map(data?.customerRates, (ratesObj) => {
        return `${
          ratesObj.data?.surcharge?.capAmount ? " RM " + ratesObj.data?.surcharge?.capAmount : "-"
        } \n`;
      })
        ?.toString()
        .replaceAll(",", ""),
      "Created Date": moment(data.createdAt).format("DD-MM-YYYY HH:MM:SS"),
      "Created By": data.createdBy || "-",
      "Updated Date": moment(data.updatedAt).format("DD-MM-YYYY HH:MM:SS"),
      "Updated By": data.updatedBy || "-",
    };
  },

  ISSUE_TYPE: (data) => {
    return {
      Code: data.code,
      Name: data.name,
      Remarks: data.remark,
      "Created Date": moment(data.createdAt).format("DD-MM-YYYY HH:MM:SS"),
      "Created By": data.createdBy || "-",
      "Updated Date": moment(data.updatedAt).format("DD-MM-YYYY HH:MM:SS"),
      "Updated By": data.updatedBy || "-",
    };
  },

  TYPE_OF_GOODS: (data) => {
    return {
      Code: data.code,
      Name: data.name,
      Remarks: data.description,
      Prohibited: data.isProhibited ? "Yes" : "No",
      "Created Date": moment(data.createdAt).format("DD-MM-YYYY HH:MM:SS"),
      "Created By": data.createdBy || "-",
      "Updated Date": moment(data.updatedAt).format("DD-MM-YYYY HH:MM:SS"),
      "Updated By": data.updatedBy || "-",
    };
  },

  INSURANCE: (data) => {
    let customerCharges = {
      "Customer Name": "",
      " Surcharge Type ": "",
      // " Value From - Value To ": '',
      // " Charges ": '',
      " Fixed Amount ": "",
      " Percentage ": "",
      " Cap Amount ": "",
      " Valid From ": "",
      " Valid To ": "",
    };

    forEach(data?.customerRates, (ratesObj) => {
      customerCharges["Customer Name"] = customerCharges["Customer Name"] + `${ratesObj.orgName}\n`;
      customerCharges[" Surcharge Type "] =
        customerCharges[" Surcharge Type "] + `${ratesObj.surchargeType}\n`;
      customerCharges[" Fixed Amount "] =
        customerCharges[" Fixed Amount "] +
        `${ratesObj.surcharge?.fixedAmount ? " RM " + ratesObj.surcharge?.fixedAmount : "-"} \n`;
      customerCharges[" Percentage "] =
        customerCharges[" Percentage "] +
        `${ratesObj.surcharge?.percentage ? ratesObj.surcharge?.percentage + "%" : "-"} \n`;
      customerCharges[" Cap Amount "] =
        customerCharges[" Cap Amount "] +
        `${ratesObj.surcharge?.capAmount ? " RM " + ratesObj.surcharge?.capAmount : "-"} \n`;
      // customerCharges[" Value From - Value To "] = customerCharges[" Value From - Value To "] + map(ratesObj?.data?.insuranceCharges,insuranceObj=>{return "RM" + insuranceObj.valueFrom + " - " + insuranceObj.valueTo + '\n'})?.toString().replaceAll(",","") + '\n';
      // customerCharges[" Charges "] = customerCharges[" Charges "] + map(ratesObj?.data?.insuranceCharges,insuranceObj=>{return "RM" + insuranceObj.charge + "\n"})?.toString().replaceAll(",","") + '\n';
      customerCharges[" Valid From "] =
        customerCharges[" Valid From "] + `${moment(ratesObj.validFrom).format("DD-MM-YYYY")}\n`;
      customerCharges[" Valid To "] =
        customerCharges[" Valid To "] + `${moment(ratesObj.validTo).format("DD-MM-YYYY")}\n`;
    });

    return {
      Code: data.code,
      Version: data.version,
      "Value From - Value To": map(data?.data?.insuranceCharges, (insuranceObj) => {
        return "\n RM" + insuranceObj.valueFrom + " - " + insuranceObj.valueTo;
      })?.toString(),
      Charges: map(data?.data?.insuranceCharges, (insuranceObj) => {
        return "\n RM" + insuranceObj.charge;
      })?.toString(),
      "Valid From": data.validFrom,
      "Valid To": data.validTo,
      ...customerCharges,
      "Created Date": moment(data.createdAt).format("DD-MM-YYYY HH:MM:SS"),
      "Created By": data.createdBy || "-",
      "Updated Date": moment(data.updatedAt).format("DD-MM-YYYY HH:MM:SS"),
      "Updated By": data.updatedBy || "-",
    };
  },

  //TODO
  RATE_TABLE: (data) => {
    let location = data.locations[0] || {};
    let weightObj = {
      "Weight From - Weight To": "",
      "Price (Before SST)": "",
      "Price (After SST)": "",
      Markup: "",
      "Markup Type": "",
      "Markup (Before SST)": "",
      "Markup (After SST)": "",
    };

    let customerCharges = {
      "Customer Name": "",
      " Surcharge Type ": "",
      // " Value From - Value To ": '',
      // " Charges ": '',
      " Fixed Amount ": "",
      " Percentage ": "",
      " Cap Amount ": "",
      " Valid From ": "",
      " Valid To ": "",
    };

    forEach(data?.customerRates, (ratesObj) => {
      customerCharges["Customer Name"] = customerCharges["Customer Name"] + `${ratesObj.orgName}\n`;
      customerCharges[" Surcharge Type "] =
        customerCharges[" Surcharge Type "] + `${ratesObj.surchargeType}\n`;
      customerCharges[" Fixed Amount "] =
        customerCharges[" Fixed Amount "] +
        `${ratesObj.surcharge?.fixedAmount ? " RM " + ratesObj.surcharge?.fixedAmount : "-"} \n`;
      customerCharges[" Percentage "] =
        customerCharges[" Percentage "] +
        `${ratesObj.surcharge?.percentage ? ratesObj.surcharge?.percentage + "%" : "-"} \n`;
      customerCharges[" Cap Amount "] =
        customerCharges[" Cap Amount "] +
        `${ratesObj.surcharge?.capAmount ? " RM " + ratesObj.surcharge?.capAmount : "-"} \n`;
      // customerCharges[" Value From - Value To "] = customerCharges[" Value From - Value To "] + map(ratesObj?.data?.insuranceCharges,insuranceObj=>{return "RM" + insuranceObj.valueFrom + " - " + insuranceObj.valueTo + '\n'})?.toString().replaceAll(",","") + '\n';
      // customerCharges[" Charges "] = customerCharges[" Charges "] + map(ratesObj?.data?.insuranceCharges,insuranceObj=>{return "RM" + insuranceObj.charge + "\n"})?.toString().replaceAll(",","") + '\n';
      customerCharges[" Valid From "] =
        customerCharges[" Valid From "] + `${moment(ratesObj.validFrom).format("DD-MM-YYYY")}\n`;
      customerCharges[" Valid To "] =
        customerCharges[" Valid To "] + `${moment(ratesObj.validTo).format("DD-MM-YYYY")}\n`;
    });

    forEach(data?.rates, (rateObj) => {
      weightObj["Weight From - Weight To"] =
        weightObj["Weight From - Weight To"] +
        "\n" +
        rateObj.weightFrom +
        "KG - " +
        rateObj.weightTo +
        "KG";
      weightObj["Price (Before SST)"] =
        weightObj["Price (Before SST)"] + "\n RM " + rateObj.priceBeforeSST;
      weightObj["Price (After SST)"] =
        weightObj["Price (After SST)"] + "\n RM " + rateObj.priceAfterSST;
      weightObj["Markup Type"] = weightObj["Markup Type"] + "\n" + rateObj.markupType;
      weightObj["Markup"] =
        weightObj["Markup"] +
        "\n" +
        (rateObj.markupType == "FIXED" ? "RM " + rateObj.markupValue : rateObj.markupValue + "%");
      weightObj["Markup (Before SST)"] =
        weightObj["Markup (Before SST)"] +
        "\n" +
        (rateObj.markupType == "FIXED"
          ? "RM " + rateObj.markupBeforeSST
          : rateObj.markupBeforeSST + "%");
      weightObj["Markup (After SST)"] =
        weightObj["Markup (After SST)"] +
        "\n" +
        (rateObj.markupType == "FIXED"
          ? "RM " + rateObj.markupAfterSST
          : rateObj.markupAfterSST + "%");
    });
    return {
      Code: data.code,
      Version: data.version,
      "Area Name": location?.areaName,
      State: map(location?.states, (stateObj) => {
        return stateObj.state;
      })?.toString(),
      "Post Codes": map(location?.states, (stateObj) => {
        return stateObj.postcodes;
      })?.toString(),
      "Service Types": map(location?.deliveryTypes[0]?.serviceTypes, (type) => {
        return type.name;
      })?.toString(),
      "Delivery Types": map(location?.deliveryTypes, (type) => {
        return type.name;
      })?.toString(),
      ...weightObj,
      Type: "Rate Table",
      "Valid From": data.validFrom,
      "Valid To": data.validTo,
      ...customerCharges,
      "Created Date": moment(data.createdAt).format("DD-MM-YYYY HH:MM:SS"),
      "Created By": data.createdBy || "-",
      "Updated Date": moment(data.updatedAt).format("DD-MM-YYYY HH:MM:SS"),
      "Updated By": data.updatedBy || "-",
    };
  },
};
